import React from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

export type ZoomableWebProps = {
  children: React.ReactNode | React.ReactNode[];
};

export default function ZoomableWeb({ children }: ZoomableWebProps) {
  return (
    <TransformWrapper>
      <TransformComponent
        wrapperStyle={{ width: '100%', height: '100%' }}
        contentStyle={{
          width: '100%',
          height: '100%',
        }}
      >
        {children}
      </TransformComponent>
    </TransformWrapper>
  );
}
